type Entries<T extends object> = { [K in keyof T]: [K, T[K]] }[keyof T];

export function reverseEnum<E extends Record<keyof E, string | number>>(
  e: E
): { [K in E[keyof E]]: Extract<Entries<E>, [any, K]>[0] };

export function reverseEnum(
  e: Record<string | number, string | number>
): Record<string | number, string | number> {
  const result: Record<string | number, string | number> = {};
  Object.keys(e).forEach((k) => (result[e[k]] = k));
  return result;
}
